import React from 'react';

const FullOpportunitiesList = ({ sampleDataFallback }) => (
  <div className="space-y-6">
    <h2 className="text-2xl font-bold text-slate-800 dark:text-white mb-6">
      📄 Full Opportunity List (Top 10)
    </h2>

    <div className="space-y-4">
      {sampleDataFallback.priorities.map((opp, index) => (
        <div
          key={opp.id}
          className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-lg p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-4">
              <div className="bg-emerald-600 dark:bg-emerald-500 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold">
                {index + 1}
              </div>
              <div>
                <h3 className="text-xl font-semibold text-slate-800 dark:text-white">
                  {opp.measure}
                </h3>
                <span className="bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 px-3 py-1 rounded-full text-sm">
                  {opp.category}
                </span>
              </div>
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">
                ${opp.savings.toLocaleString()}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {opp.payback} years payback
              </p>
            </div>
          </div>

          <p className="text-gray-700 dark:text-gray-300 mb-3">{opp.description}</p>
          <p className="text-sm text-gray-600 dark:text-gray-400">{opp.details}</p>

          <div className="mt-4 flex items-center justify-between">
            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                opp.confidence === 'High'
                  ? 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300'
                  : 'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300'
              }`}
            >
              {opp.confidence} Confidence
            </span>
            <div className="text-sm text-emerald-600 dark:text-emerald-400 font-medium">
              {opp.productivity}
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-lg border border-slate-200 dark:border-slate-700">
      <h3 className="text-lg font-semibold text-slate-800 dark:text-white mb-4">
        Additional Opportunities (6-10)
      </h3>
      <div className="space-y-3">
        {sampleDataFallback.fullOpportunities.map((opp, index) => (
          <div
            key={index}
            className="flex items-center justify-between bg-white dark:bg-gray-700 p-4 rounded-lg border border-slate-200 dark:border-slate-600"
          >
            <div className="flex items-center gap-3">
              <span className="text-2xl">{opp.logo}</span>
              <div>
                <h4 className="font-medium text-slate-800 dark:text-white">
                  {opp.measure}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Partner: {opp.partner}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-bold text-emerald-600 dark:text-emerald-400">
                ${opp.savings.toLocaleString()}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {opp.payback} years • {opp.cost}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FullOpportunitiesList;


